import React from "react";
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'
import toyota from '../assets/images/toyota.png'; 
import combined from '../assets/images/English_Combined-removebg-preview.png'; 
import koduu from '../assets/images/Koduu_logo_white.svg';
import solSystems from '../assets/images/SOL-Logo-1.svg';
import magnet from "../assets/images/magnet_forensics_logo.jpeg";
import relocal from "../assets/images/relocaljobs_logo.jpeg";
import guelph from "../assets/images/university_of_guelph_logo.jpeg";
import luje from "../assets/images/lujeio_logo.jpeg";

function Timeline() {
  const timelineElements = [
    {
      id: 1,
      date: "July 2026 - Present",
      title: "Forward Deployed Engineering",
      subtitle: "Luje.io, Toronto, Ontario",
      description: "Fall 2026",
      logo: luje,
      icon: <img src={luje} alt="Luje.io" style={{ width: '100%', height: '100%', borderRadius: '50%' }} />,
    },
    {
      id: 2,
      date: "May 2026 - Present",
      title: "Undergraduate Research Assistant",
      subtitle: "University of Guelph, Guelph, Ontario",
      description: "Conducting research on LLM Information Retrieval under Professor John Akinyemi.",
      logo: guelph,
      icon: <img src={guelph} alt="University of Guelph" style={{ width: '100%', height: '100%', borderRadius: '50%' }} />,
    },
    {
      id: 3,
      date: "May 2026 - Present",
      title: "Software Engineering",
      subtitle: "Magnet Forensics, Waterloo, Ontario",
      description: "Artifacts Engineering for Magnet Forensics' flagship product, AXIOM. Developed and maintained parsers for various digital artifacts using Python, C#, and .NET, contributing to the recovery of critical evidence in digital forensic investigations.",
      logo: magnet,
      icon: <img src={magnet} alt="Magnet Forensics" style={{ width: '100%', height: '100%', borderRadius: '50%' }} />,
    },
    {
        id: 4,
        date: "January 2026 - April 2026",
        title: "AI Engineering",
        subtitle: "Relocal, Toronto, Ontario",
        description: "Python, FastAPI, Django, React, Typescript, Docker, Github Actions, Gemini, AWS",
        logo: relocal,
        icon: <img src={relocal} alt="Relocal" style={{ width: '100%', height: '100%', borderRadius: '50%' }} />,
    },
    {
        id: 5,
        date: "September 2025 - December 2025",
        title: "Software Engineering",
        subtitle: "Toyota, Cambridge, Ontario",
        description: "Java Springboot, Angular, Kafka, .NET, Redis, MQTT, Docker",
        logo: toyota,
        icon: <img src={toyota} alt="Toyota" style={{ width: '100%', height: '100%', borderRadius: '50%' }} />,
    },
    {
        id: 6,
        date: "May 2025 - August 2025",
        title: "Test Automation Engineering",
        subtitle: "Combined Insurance, Markham, Ontario",
        description: "Python, Pandas, Selenium, Pyppeteer, Excel, SDLC, Agile Methodologies, Third Party Risk Management",
        logo: combined,
        icon: <img src={combined} alt="Combined Insurance" style={{ width: '100%', height: '100%', borderRadius: '50%' }} />,
    },
    {
        id: 7,
        date: "January 2025 - April 2025",
        title: "Software Engineering",
        subtitle: "Koduu, Toronto, Ontario",
        description: "Cloud Data Pipelines, webscraping services, frontend components and backend microservices for Vox-mail AI & Shredvision with Google Cloud Platform, Firebase, Python, Node.js, React, and Typescript",
        logo: koduu,
        icon: <img src={koduu} alt="Koduu" style={{ width: '100%', height: '100%', borderRadius: '50%', background: 'black', padding: '5px' }} />,
    },
    {
        id: 8,
        date: "May 2024 - August 2024",
        title: "Software Engineering",
        subtitle: "Sol Systems, Oakville, Ontario",
        description: "Flask, React, SQL, Docker, Kubernetes, and a little .NET",
        logo: solSystems,
        icon: <img src={solSystems} alt="Sol Systems" style={{ width: '100%', height: '100%', borderRadius: '50%', background: 'black', padding: '5px' }} />,
    }
  ];

  return (
    <div id="history">
      <div className="items-container">
        <h1>Career History</h1>
        <VerticalTimeline>
          {timelineElements.map(element => (
            <VerticalTimelineElement
              key={element.id}
              className="vertical-timeline-element--work"
              contentStyle={{ background: '#fff', color: '#000' }}
              contentArrowStyle={{ borderRight: '7px solid  #fff' }}
              date={element.date}
              iconStyle={{ background: '#fff', color: '#000' }}
              icon={element.icon}
            >
              <h3 className="vertical-timeline-element-title">{element.title}</h3>
              <h4 className="vertical-timeline-element-subtitle">{element.subtitle}</h4>
              <p>{element.description}</p>
            </VerticalTimelineElement>
          ))}
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;
